import { useEffect, useState } from 'react'

import { useAuth } from 'store/auth/useAuth'

import { changeCoursesOrder, getMatchSpeciality } from 'components/search/webinar-search/utils'
import { getAxiosCounted } from 'pages/api/axios'
import { ICourseNmoType } from 'constants/types/card.types'
import { BASE_URL } from 'constants/url'

const DEFAULT_COURSE_ORDER = [3, 4, 1, 0, 2]
// 3. когнитивные расстройства
// 4. современная гериатрия
// 1. остеопороз
// 0. жкт
// 2. кардиология

const useGetNmoCourses = () => {
  const { userProfile } = useAuth()
  const [coursesCards, setCoursesCards] = useState<ICourseNmoType[]>([])

  useEffect(() => {
    let courseOrder = getMatchSpeciality(userProfile.Specialities)
    if (!courseOrder) courseOrder = DEFAULT_COURSE_ORDER
    const getData = async () => {
      const allCourses = await getAxiosCounted(`${BASE_URL.NMO_COURSE}/getShortList`)
      const updatedCourserOrder = changeCoursesOrder(allCourses.rows, courseOrder)
      setCoursesCards(updatedCourserOrder)
    }
    getData()
  }, [userProfile])

  return coursesCards
}

export default useGetNmoCourses
